<template>
  <div class="level">
    <div class="level-left">
      <slot></slot>
    </div>

    <div v-if="view" class="level-right">
      <span
        class="icon"
        @click="$emit('change', 1)"
        :class="{ 'has-text-primary': view == 1, 'has-text-grey': view != 1 }"
        data-tooltip="Simple view"
      >
        <i class="mdi mdi-view-week"></i>
      </span>

      <span
        class="icon"
        @click="$emit('change', 2)"
        :class="{ 'has-text-primary': view == 2, 'has-text-grey': view != 2 }"
        data-tooltip="Detail view"
      >
        <i class="mdi mdi-view-headline"></i>
      </span>
    </div>
  </div>
</template>

<style lang="css" scoped></style>

<script>
export default {
  props: { view: Number }
};
</script>
